// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalContainer_wYgYB {
  display: flex;
  justify-content: center;
  align-items: center;

  .CorporativeModalText_ZB0rk {
    display: flex;
    flex-direction: column;

    align-items: center;
    width: 90%;
    height: 80%;
    margin: 0px auto 10px;
    padding: 15px 10px 10px 10px;
    border-radius: 10px;
    background-color: var(--white-background);

    .textContainer_AzQkL {
      margin: 12px 0 24px 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: var(--black-color);
    }

    p {
      font-size: 14px;
      color: var(--595959-color);
      text-align: center;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.13px;
      margin: 0;
    }




  }
}


.buttonContainer_Oftsu {
  display: flex;
  gap: 10px;
}

.iconContainer_XJ3dp {
  width: 100%;
  display: flex;
  justify-content: center;
}

.textContainerGeneral_mOHZp {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70%;
}

.modalAndHeaderContainer_cqMFU {
  background: var(--f5-background);
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CorporativeModalText/CorporativeModalText.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;IACE,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,4BAA4B;IAC5B,mBAAmB;IACnB,yCAAyC;;IAEzC;MACE,qBAAqB;MACrB,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,yBAAyB;IAC3B;;IAEA;MACE,eAAe;MACf,0BAA0B;MAC1B,kBAAkB;MAClB,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,sBAAsB;MACtB,SAAS;IACX;;;;;EAKF;AACF;;;AAGA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".modalContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .CorporativeModalText {\n    display: flex;\n    flex-direction: column;\n\n    align-items: center;\n    width: 90%;\n    height: 80%;\n    margin: 0px auto 10px;\n    padding: 15px 10px 10px 10px;\n    border-radius: 10px;\n    background-color: var(--white-background);\n\n    .textContainer {\n      margin: 12px 0 24px 0;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      color: var(--black-color);\n    }\n\n    p {\n      font-size: 14px;\n      color: var(--595959-color);\n      text-align: center;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 22px;\n      letter-spacing: 0.13px;\n      margin: 0;\n    }\n\n\n\n\n  }\n}\n\n\n.buttonContainer {\n  display: flex;\n  gap: 10px;\n}\n\n.iconContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.textContainerGeneral {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 70%;\n}\n\n.modalAndHeaderContainer {\n  background: var(--f5-background);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `modalContainer_wYgYB`,
	"CorporativeModalText": `CorporativeModalText_ZB0rk`,
	"textContainer": `textContainer_AzQkL`,
	"buttonContainer": `buttonContainer_Oftsu`,
	"iconContainer": `iconContainer_XJ3dp`,
	"textContainerGeneral": `textContainerGeneral_mOHZp`,
	"modalAndHeaderContainer": `modalAndHeaderContainer_cqMFU`
};
export default ___CSS_LOADER_EXPORT___;
